export default __webpack_public_path__ + "static/media/rocket.23ae6f57.png";